
import { JSX, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Dialog, DialogContent, DialogContentText, Button, DialogActions, Grid, Select, TextField, Box, MenuItem, Typography } from '@mui/material';

import EditIcon from "@mui/icons-material/Edit";

import Flag from 'react-country-icons';

import { RootState } from '../store';
import { setReducerRecepcion } from '../store/slices/RecepcionSlice';
import { openSnackbar } from '../store/slices/SnackbarSlice';

import { ClearFormatPhoneNumber, FormatInternationalPhone, FormatPhoneNumber } from '../helpers/FormatPhoneNumber';

import { DialogActionsStyle } from '../styles/DialogStyle';

import { EnviarAcuseWhatsApp } from '../connections/comun/RecepcionConnection';

interface Props {
    telefonoCelular:    string;
    openDialog:         boolean;
    handleCloseDialog:  () => void;

}

interface CountryOption {
    code:   string;
    label:  string;
    phone:  string;
    flag:   JSX.Element;
}

const countries: CountryOption[] = [
    {
        code: "MX",
        label: "México",
        phone: "+52",
        flag: <Flag size={22} country='MX' />,
    },
    {
        code: "US",
        label: "Estados Unidos",
        phone: "+1",
        flag: <Flag size={22} country='US' />,
    },
];

export const DialogEnviarWhatsApp = ( { openDialog, telefonoCelular, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );
        
    const [telefono, setTelefono] = useState( '' );
    const [codigoPais, setCodigoPais] = useState( 'MX' );
    
    const [loadingSend, setLoadingSend] = useState( false );
    const [editTelefono, setEditTelefono] = useState( false );

    const handleClose = () => {

        setEditTelefono( false );
        handleCloseDialog();

    }

    const handleEnviarAcuse = async () => {

        const country = countries.find( (c) => c.code === codigoPais );

        if( !country ){

            dispatch( openSnackbar({ message: 'Seleccione la lada del país de origen', variant: 'warning' })); 
            return;
        }

        setLoadingSend( true );

        let phoneNumber = '';

        if( editTelefono || !telefonoCelular ){
            phoneNumber = `${ country.phone }${ ClearFormatPhoneNumber( telefono ) }`;
        }
        else {
            phoneNumber = telefono;
        }

        await EnviarAcuseWhatsApp({ id: recepcion.id ?? '', telefonoCelular: phoneNumber }).then( resp => {
                
            const { success, message } = resp;

            if( success ){

                setTimeout(() => {                        
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));   

                    dispatch( setReducerRecepcion({ ...recepcion, telefonoCelular: telefono }) );

                    handleCloseDialog();

                    setLoadingSend( false );
                    
                }, 700);

            }
            else {

                setTimeout(() => {                    
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' })); 

                    setLoadingSend( false );

                }, 700);

            }

        }); 

    }

    useEffect(() => {
  
        if( openDialog ){
            setTelefono( telefonoCelular  );
        }

    }, [ openDialog, telefonoCelular ])    

    return (
        <Dialog 
            maxWidth="xs"
            fullWidth={ true } 
            open={ openDialog } 
            onClose={ () => {} } 
        >           

            <DialogContent sx={{ textAlign: 'center' }}>  

                <DialogContentText my={2}>
                    Se enviará el acuse de recibo al siguiente número:
                </DialogContentText>

                {                   
                    ( editTelefono || !telefonoCelular )
                    ?
                        <Grid container spacing={1} mt={3}>

                            <Grid size={{ md: 4, xs: 12 }}>
                                
                                <Select
                                    fullWidth
                                    value={ codigoPais }
                                    onChange={ (e) => {
                                        const selected = countries.find( (c) => c.code === e.target.value );
                                        if ( selected ){ setCodigoPais(selected.code); }
                                    }}
                                    renderValue={ ( value ) => {

                                        const country = countries.find( (c) => c.code === value );

                                        if( !country){ return <Box> </Box>; }

                                        return <Box display="flex" alignItems="center" gap={1}>

                                            { country.flag }

                                            <Typography variant="body1">
                                                { country.phone }
                                            </Typography>

                                        </Box>;
                                    }}                            
                                >
                                    {
                                        countries
                                        .map( (option) => (
                                            <MenuItem key={ option.code} value={ option.code }>

                                                <Box display="flex" alignItems="center" gap={1} my={1}>

                                                    { option.flag }

                                                    <Typography variant="body2">
                                                        { option.label } ({ option.phone })
                                                    </Typography>

                                                </Box>

                                            </MenuItem>
                                        ))
                                    }
                                </Select>

                            </Grid>
                        
                            <Grid size={{ md: 8, xs: 12 }}>

                                <TextField
                                    fullWidth
                                    placeholder="(000) 000-0000"                                                        
                                    value={ telefono }
                                    onChange={ (e) => setTelefono( FormatPhoneNumber( e.target.value ) ) }
                                    slotProps={{
                                        input: {
                                            sx: {
                                                textAlign: "center",
                                                fontSize: 16,
                                                letterSpacing: 6,
                                                borderRadius: 1,
                                            },
                                        }
                                    }}          
                                />  

                            </Grid>

                        </Grid>      
                    :
                        telefonoCelular
                        &&
                            <Button
                                color='secondary'
                                sx={{ my: 1, fontSize: 16 }}
                                endIcon={ <EditIcon /> }
                                onClick={ () => { setTelefono( '' ); setEditTelefono( true ); }}
                            >
                                { FormatInternationalPhone( telefonoCelular ) }
                            </Button>
                }

            </DialogContent> 

            <DialogActions sx={ DialogActionsStyle }>
            
                <Button color='secondary' disabled={ loadingSend } onClick={ handleClose }> Cancelar </Button>
                <Button variant='contained' disabled={ telefono === '' } loading={ loadingSend } onClick={ handleEnviarAcuse }> Enviar </Button>
                
            </DialogActions>

        </Dialog>  
    )
}
